import useHandleAppException, {
  isAppExceptionResponseData,
} from '../../../../../../../../../hooks/useHandleAppException';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';

const getResponseData = (error: unknown) =>
  (error as { response?: { data?: unknown } } | null)?.response?.data;

export const isUnavailableIntegrationError = (error: unknown) => {
  const data = getResponseData(error);

  return !isAppExceptionResponseData(data) || data.code === LangEnum.API_EXCEPTION_TMS_QUOTE_FAILED;
};

const useFreightQuoteError = () => {
  const { translate } = useTranslation();
  const { handleError } = useHandleAppException();

  const getErrorMessage = (error: unknown) => {
    const data = getResponseData(error);

    if (!isAppExceptionResponseData(data) || isUnavailableIntegrationError(error)) {
      return translate(LangEnum.API_EXCEPTION_TMS_QUOTE_FAILED);
    }

    return handleError(data);
  };

  return { getErrorMessage };
};

export default useFreightQuoteError;
